import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)
export default new Vuex.Store({
  state: {
    showLoading: false,
    bizNumber: '',
    MailTab: 1, // 默认个人信箱的切换tab选择是1
    activeNumTab: 1// 默认设置个人主页的tab激活显示为个人项

    // cmptId:'',
    // cmptName:''
  },
  mutations: {
    // LoadingShow: function (state) {
    //   state.showLoading = true;
    //   window.localStorage.setItem('showLoading',true)
    // },
    // LoadingHide: function (state) {
    //   state.showLoading = false;
    //   window.localStorage.setItem('showLoading',false)
    // },
    // setCmptId: function (state,id) {
    //   state.cmptId = id;
    //   window.localStorage.setItem('cmptId',id)
    // },
    // setCmptName: function (state,name) {
    //   state.cmptName = name;
    //   window.localStorage.setItem('cmptName',name)
    // }
  }
})



// WEBPACK FOOTER //
// ./src/store/store.js